
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Impfaktion from '@/types/Impfaktion';
    import { DataTableHeaders, DataTableHeaderType } from '@/types';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import ImpfaktionenDetail from '@/components/Impfaktionen/ImpfaktionenDetail.vue';

    @Component({
        components: {
            ImpfaktionenDetail,
        },
        computed: {
            ...mapState('impfaktionen', ['impfaktionen', 'dialogs', 'loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('impfaktionen', ['loadImpfaktionen']),
            ...mapMutations('impfaktionen', ['setDialogsDetail']),
        },
    })
    export default class Impfaktionen extends Vue {
        public impfaktion = new Impfaktion();
        public search = '';

        public loadImpfaktionen!: () => void;
        public setDialogsDetail!: (visible: boolean) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public get headers(): DataTableHeaders<Impfaktion> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Bezeichnung', value: 'bezeichnung' },
                { text: 'Impfstoff ', value: 'impfstoff_name' },
                { text: 'Preis', value: 'preis'},
                { text: 'Preis Mitarbeiter', value: 'preis_mitarbeiter'},
                { text: 'Preis Rektorat', value: 'preis_rektorat' },
                { text: 'Von', value: 'von' },
                { text: 'Bis', value: 'bis' },
                { text: 'Leistung Kostenbet.', value: 'leistung_name'},
                { text: 'Extern', value: 'gueltig_extern', class: 'group_muw_left', width: 50},
                { text: 'MUW Mitarbeiter', value: 'gueltig_muw_mitarbeiter', class: 'group_muw', width: 50},
                { text: 'MUW Mitarbeiter HCW', value: 'gueltig_muw_mitarbeiter_hcw', class: 'group_muw', width: 50 },
                { text: 'MUW Angehörige', value: 'gueltig_muw_angehoerige', class: 'group_muw', width: 50 },
                { text: 'Medstudent', value: 'gueltig_medstudent', class: 'group_muw', width: 50 },
                { text: 'Medstudent HCW', value: 'gueltig_medstudent_hcw', class: 'group_muw_right', width: 50 },
                { text: 'Gültig', value: 'gueltig' },
                //{ text: 'letzte Änderung', value: 'fw_modified' },
                //{ text: 'Benutzer', value: 'fw_modified_user' },
            ].filter((header) => header) as DataTableHeaders<Impfaktion>;
        }

        public mounted(): void {
            this.loadImpfaktionen();
        }

        public onClickEdit(impfaktion: Impfaktion): void {
            this.impfaktion = new Impfaktion(impfaktion);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.impfaktion = new Impfaktion();
            this.setDialogsDetail(true);
        }
    }
